import React from 'react';
import { Box, Paper, Skeleton } from '@mui/material';

const PaymentSuccessSkeleton: React.FC = () => (
  <Box sx={{ 
    minHeight: '100vh', 
    width: '100vw', 
    background: 'linear-gradient(135deg, #f5f5f5 0%, #e8f5e9 100%)', 
    py: 4 
  }}>
    <Box maxWidth="sm" sx={{ mx: 'auto', pb: { xs: 10, sm: 4 } }}>
      {/* Success Icon and Header Skeleton */}
      <Box sx={{ 
        mt: 0, 
        mb: 3,
        mr: 3,
        ml: 3,
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2
      }}>
        <Skeleton variant="circular" width={80} height={80} />
        <Skeleton variant="text" width="60%" height={40} />
        <Skeleton variant="text" width="80%" height={24} />
      </Box>

      {/* Payment Details Card Skeleton */}
      <Paper sx={{ 
        p: 3, 
        mb: 3, 
        borderRadius: 3, 
        boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
        mr: 3,
        ml: 3
      }}>
        <Skeleton variant="text" width="50%" height={28} sx={{ mb: 2 }} />
        
        {/* Payment Items Skeleton */}
        {[1, 2].map((item) => (
          <Box key={item} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
            <Box sx={{ flex: 1 }}>
              <Skeleton variant="text" width="60%" height={20} />
              <Skeleton variant="text" width="40%" height={16} />
            </Box>
            <Skeleton variant="text" width="20%" height={20} />
          </Box>
        ))}
        
        {/* Total Section Skeleton */}
        <Box sx={{ borderTop: '1px solid #e0e0e0', pt: 2, mt: 2 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
            <Skeleton variant="text" width="30%" height={24} />
            <Skeleton variant="text" width="25%" height={28} />
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
            <Skeleton variant="text" width="25%" height={20} />
            <Skeleton variant="text" width="20%" height={20} />
          </Box>
        </Box>
      </Paper>

      {/* Action Buttons Skeleton */}
      <Box sx={{ mr: 3, ml: 3, display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Skeleton variant="rounded" width="100%" height={48} sx={{ borderRadius: 2 }} />
        <Skeleton variant="rounded" width="100%" height={48} sx={{ borderRadius: 2 }} />
      </Box>
    </Box>
  </Box>
);

export default PaymentSuccessSkeleton; 